import {createSvgIcon} from '../create-svg-icon';

export const SpaceBarIcon = createSvgIcon(
  <path d="M18 9v4H6V9H4v6h16V9h-2z" />
, 'SpaceBarOutlined');
